/** Canonical Freestar ACF / Gutenberg block name. */
export const FREESTAR_AD_BLOCK_NAME = 'acf/freestar-ad-placement';

/**
 * Legacy WP slug still in content until the editor block is renamed.
 * Fusion renders Freestar for both names.
 */
export const LEGACY_DISPLAY_AD_BLOCK_NAME = 'acf/raptive-ad-placement';

export const DISPLAY_AD_BLOCK_NAMES = [FREESTAR_AD_BLOCK_NAME, LEGACY_DISPLAY_AD_BLOCK_NAME] as const;

export type DisplayAdBlockName = (typeof DISPLAY_AD_BLOCK_NAMES)[number];

export const isDisplayAdBlockName = (blockName: string | null | undefined): blockName is DisplayAdBlockName =>
  !!blockName && (DISPLAY_AD_BLOCK_NAMES as readonly string[]).includes(blockName);

/** @deprecated Use FREESTAR_AD_BLOCK_NAME or LEGACY_DISPLAY_AD_BLOCK_NAME */
export const RAPTIVE_AD_BLOCK_NAME = LEGACY_DISPLAY_AD_BLOCK_NAME;
